import {
    moveToFolderNewFolderText,
    moveToArchiveMbxFolderNewFolderText,
    searchFolder,
    searchArchiveFolder,
    moveToSearchSharedFolder,
    moveToFolderCreateNewText,
    moveToArchiveMbxFolderCreateNewText,
} from './moveToStringUtils.locstring.json';
import loc, { format } from 'owa-localize';
import type { MailboxType } from 'owa-graph-schema';

import getMailboxFolderTreeDataTable from 'owa-folders/lib/selectors/getMailboxFolderTreeDataTable';
import { getStore } from '../store/store';

/**
 * New folder menu item's text in moveTo mailbox menu
 */
export function getMoveToNewFolderText(moveToMailboxType: MailboxType) {
    switch (moveToMailboxType) {
        case 'UserMailbox':
            return loc(moveToFolderNewFolderText);

        case 'ArchiveMailbox':
            return loc(moveToArchiveMbxFolderNewFolderText);

        case 'SharedMailbox':
            return '';

        default:
            throw new Error('Correct moveToMailboxType should be set');
    }
}

/**
 * The placeholder text for search box
 */
export function getSearchBoxLabelText(moveToMailboxType: MailboxType) {
    const { moveToSharedFolderRootId } = getStore();
    switch (moveToMailboxType) {
        case 'UserMailbox':
            return loc(searchFolder);

        case 'ArchiveMailbox':
            return loc(searchArchiveFolder);

        case 'SharedMailbox':
            return format(
                loc(moveToSearchSharedFolder),
                getMailboxFolderTreeDataTable().get(moveToSharedFolderRootId).rootFolder.displayName
            );

        default:
            throw new Error('Correct moveToMailboxType should be set');
    }
}

/**
 * Whenever the find text is not matched with any folder in moveTo mailbox menu then an item for create new folder with that same name is shown
 * This function returns what name should be shown in that item
 */
export function getNewFolderTextFromFindText(moveToMailboxType: MailboxType) {
    switch (moveToMailboxType) {
        case 'UserMailbox':
            return loc(moveToFolderCreateNewText);

        case 'ArchiveMailbox':
            return loc(moveToArchiveMbxFolderCreateNewText);

        case 'SharedMailbox':
            return '';

        default:
            throw new Error('Correct moveto mailboxType should be set');
    }
}
